import { enums } from "../../common/lib";
import { useState, useMemo } from "react";
import { useSelector } from "react-redux";

export default (actionBtnUpdate, assetMode) => {
    const [showExclusionDatePicker, setShowExclusionDatePicker] =
        useState(false);
    const [isDateRequired, setIsDateRequired] = useState(false);
    const [disableDatePicker, setDisableDatePicker] = useState(false);

    const { assetDetails, typesList } = useSelector((state) => state);

    const exclusionReasonTypes = typesList.exclusionReasonTypes.data;
    const {
        exclusionReasonTypeId,
        exclusionReasonDate,
        excludeAssetsStep,
        excludeAssets,
        steps,
        notes,
        stepsCompleted,
        photos,
    } = assetDetails;

    /** If the steps are not satisfied
     * disable the check asset condition
     */
    const disableCheck = useMemo(() => {
        // to prevent button state flickering
        if (stepsCompleted.length === 0) return true;

        // validate that all mandatory steps are complete
        const validateMandatorySteps = (element, index) =>
            !element && steps[index] && steps[index].isMandatory;

        return stepsCompleted.some(validateMandatorySteps);
    }, [assetDetails]);

    /** Disable exclude asset button  */
    const disabledExclude = useMemo(() => {
        /** Is exclusion datepicker required
         * We have to use ids instead of the name
         */
        const { assetIsSold, assetDeliveredToCustomerAndNotPaid } =
            enums.exclusionReason;

        const currentDate = new Date();

        if (
            exclusionReasonTypeId === assetDeliveredToCustomerAndNotPaid &&
            exclusionReasonDate !== null
        ) {
            return false;
        }
        if (
            exclusionReasonTypeId === assetDeliveredToCustomerAndNotPaid &&
            disableDatePicker
        )
            return false;
        if (!exclusionReasonTypeId || notes.content === "") return true;
        if (
            (exclusionReasonTypeId === assetIsSold &&
                exclusionReasonDate === null) ||
            exclusionReasonDate > currentDate
        )
            return true;
        if (excludeAssetsStep === 2 && excludeAssets.length === 0) {
            return true;
        } else return false;
    }, [
        disableDatePicker,
        exclusionReasonTypes,
        exclusionReasonTypeId,
        notes,
        exclusionReasonDate,
        excludeAssetsStep,
        excludeAssets,
    ]);

    /** For updating the asset
     * 1. It should have a note  OR
     * 2. It should have a image
     */
    const disabledUpdateAsset = useMemo(() => {
        /** remove empty images before sending */
        const images = photos.filter((item) => {
            if (Object.keys(item).length > 0) return item;
        });

        return notes.content.length < 1 && images.length < 1 ? true : false;
    }, [notes, photos]);

    // Check if the step is complete.
    const isStepComplete = useMemo(() => {
        /** If all the steps have photos then add new step with the image */
        const isImageLength = steps.filter((item) => item.isImage).length;

        const images = photos.filter((item) => {
            if (Object.keys(item).length > 0) return item;
        });

        if (assetMode.includes("update")) {
            return images.length === isImageLength ? true : false;
        } else {
            return isImageLength !== 0 && images.length === isImageLength;
        }
    }, [steps, photos, assetMode]);

    // Show Steps
    const showSteppers = useMemo(() => {
        if (assetMode.includes("exclude")) return true;
        else if (!actionBtnUpdate && assetMode.includes("updatechecked"))
            return true;
        else if (!actionBtnUpdate && assetMode.includes("unchecked"))
            return true;
        else return false;
    }, [assetMode, actionBtnUpdate]);

    return {
        disableCheck,
        disabledExclude,
        disabledUpdateAsset,
        showSteppers,
        isStepComplete,
        isDateRequired,
        setIsDateRequired,
        showExclusionDatePicker,
        setShowExclusionDatePicker,
        disableDatePicker,
        setDisableDatePicker,
    };
};
